import React, { useEffect, useState } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Button,
    Grid,
    TextField
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchAppointmentByUuid } from '../../../services/appointments';

const ViewConsultationPage = () => {
    const { uuid } = useParams();
    const navigate = useNavigate();

    const [consult, setConsult] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadConsultation = async () => {
            try {
                const data = await fetchAppointmentByUuid(uuid);
                setConsult(data);
            } catch (err) {
                console.error('Erro ao carregar consulta', err);
            } finally {
                setLoading(false);
            }
        };

        loadConsultation();
    }, [uuid]);

    if (loading) {
        return <Typography>A carregar consulta…</Typography>;
    }

    if (!consult) {
        return <Typography>Consulta não encontrada</Typography>;
    }

    const { notes } = consult;

    return (
        <Box mt={2}>
            <Card>
                <CardContent sx={{ backgroundColor: '#f9f9f9' }}>
                    <Typography variant="h5" fontWeight={700} mb={1}>
                        Consulta
                    </Typography>

                    <Box
                        sx={{
                            height: 3,
                            width: 80,
                            backgroundColor: '#1976d2',
                            borderRadius: 2,
                            mb: 3
                        }}
                    />

                    <Grid container spacing={2}>
                        {/* NOTAS DA CONSULTA */}
                        <Grid item xs={12}>
                            <Typography variant="h5">Notas da Consulta</Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                multiline
                                minRows={6}
                                label="Descrição da consulta"
                                value={notes || ''}
                                disabled
                            />
                        </Grid>
                    </Grid>

                    <Box display="flex" justifyContent="flex-end" mt={4}>
                        <Button variant="outlined" onClick={() => navigate(-1)}>
                            Voltar
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};

export default ViewConsultationPage;
